import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {TeamModel} from "../../../teams/models/team.model";
import {GroupModel} from "../../../groups/models/group.model";

export class BringozFiltersSubFiltersPanel implements IController {

  tags: any;
  groups: GroupModel[];
  teams: TeamModel[]
  queryMap: any;
  includedFilters: string[];
  onFiltersChange: Function;

  /* @ngInject */
  constructor(private $mdPanel) {
  }

  $onInit() {
  }

  ///////////////////////////////////////////////////////////
  ///////////////////  Public Functions ////////////////////
  //////////////////////////////////////////////////////////

  hasNoFilters() {
    return !_.get(this.tags, 'length')
  }


  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_END,
        this.$mdPanel.yPosition.ALIGN_TOPS // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-filters-sub-filters-btn')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          tags: this.tags || [],
          groups: this.groups || [],
          teams: this.teams || [],
          parentScope: this,
          queryMap: this.queryMap,
          includedFilters: this.includedFilters
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: BringozFiltersSubFiltersPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/commons/components/bringoz-filters-sub-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      tags: filterConfig.tags,
      groups: filterConfig.groups,
      teams: filterConfig.teams
    })
  }
}

class BringozFiltersSubFiltersPanelCtrl implements IController {

  public filterConfig: any;
  private siteId: string;
  public queryMap: any;
  public includedFilters: string[]
  public selectedGroupIds: string[];
  public selectedTeamIds: string[];

  constructor(private mdPanelRef, private $q: IQService, private $mdSelect) {
    this.siteId = mdPanelRef.config.locals.data.siteId;

    this.filterConfig = {
      tags: mdPanelRef.config.locals.data.tags,
      groups: mdPanelRef.config.locals.data.groups,
      teams: mdPanelRef.config.locals.data.teams
    };

    this.includedFilters = mdPanelRef.config.locals.data.includedFilters;
    this.queryMap = mdPanelRef.config.locals.data.queryMap;
    this.selectedGroupIds = this.filterConfig.groups?.map(g => g.id);
    this.selectedTeamIds = this.filterConfig.teams?.map(t => t.id);

  }

  onChangeTags(tags) {
    this.filterConfig.tags = tags;
  }


  onChangeGroups(groups) {
    this.filterConfig.groups = groups;
    this.selectedGroupIds = groups?.map(g => g.id);
  }

  onChangeTeams(teams) {
    this.filterConfig.teams = teams;
    this.selectedTeamIds = teams?.map(t => t.id);
  }

  isDisplayFilter(filterName: string) {
    return this.includedFilters.includes(filterName);
  }

  onReset() {
    this.filterConfig = {
      tags: [],
      groups: [],
      teams: []
    };
    this.submit()
  }


  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.filterConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }


  cancel() {
    this.mdPanelRef.close();
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozFiltersSubFiltersPanel', {
    bindings: {
      tags: '<?',
      groups: '<?',
      teams: '<?',
      includedFilters: '<?',
      queryMap: '<?',
      onFiltersChange: '&'
    },
    template: require('./bringoz-filters-sub-filters-panel.html').default,
    controller: BringozFiltersSubFiltersPanel
  });
